import { useSelector } from 'react-redux';
import { selectUserAttributes } from '@features/auth/slice';

export function useIsMultiMerchant(): boolean {
  const attrs = useSelector(selectUserAttributes);
  const isMerchant = attrs.entity?.some((v) => v?.toLowerCase() === 'merchant');
  const isMulti = attrs.type?.some((t) => t?.toLowerCase() === 'multi');
  return Boolean(isMerchant && isMulti);
}
